import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { moduleRoleGuard } from './guards/module-role.guard';
import { permisosGuard } from './guards/permisos.guard';
import { ROLES_CONFIG } from './models/roles.enum';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./dashboard/dashboard.component'),
    canActivate: [authGuard],
  },
  {
    path: 'login',
    loadComponent: () => import('./login/login.component'),
  },
  {
    path: 'actualiza-password/:codigoValidacion',
    loadComponent: () =>
      import('./actualiza-password/actualiza-password.component'),
  },
  {
    path: 'bitacora',
    loadComponent: () => import('./bitacora/bitacora.component'),
    canActivate: [authGuard],
  },
  {
    path: 'bitacora/consulta',
    loadComponent: () =>
      import('./bitacora/bitacora-consulta/bitacora-consulta.component'),
    canActivate: [authGuard],
  },
  {
    path: 'reporte-proyectos',
    loadComponent: () =>
      import('./admin/reporte-proyectos/reporte-proyectos.component').then(
        (c) => c.ReporteProyectosComponent
      ),
    canActivate: [authGuard, permisosGuard],
    data: { modulo: 'REPORTE_PROYECTOS', permiso: 'VIEW', allowedRoles: ROLES_CONFIG.REPORTE_PROYECTOS },
  },
  {
    path: 'empleados',
    loadComponent: () => import('./admin/empleados/empleados.component'),
    canActivate: [authGuard, permisosGuard],
    data: { modulo: 'EMPLEADOS', permiso: 'VIEW', allowedRoles: ROLES_CONFIG.EMPLEADOS },
  },
  {
    path: 'permisos-usuarios',
    loadComponent: () => import('./admin/permisos-usuarios/permisos-usuarios.component'),
    canActivate: [authGuard, permisosGuard],
    data: { modulo: 'EMPLEADOS', permiso: 'VIEW', allowedRoles: ROLES_CONFIG.EMPLEADOS },
  },
  {
    path: 'clientes',
    loadComponent: () => import('./admin/clientes/clientes.component'),
    canActivate: [authGuard, permisosGuard],
    data: { modulo: 'CLIENTES', permiso: 'VIEW', allowedRoles: ROLES_CONFIG.CLIENTES },
  },
  {
    path: 'proveedores',
    loadComponent: () => import('./admin/proveedores/proveedores.component'),
    canActivate: [authGuard, permisosGuard],
    data: { modulo: 'PROVEEDORES', permiso: 'VIEW', allowedRoles: ROLES_CONFIG.PROVEEDORES },
  },
  {
    path: 'proyectos',
    loadComponent: () => import('./admin/proyectos/proyectos.component'),
    canActivate: [authGuard, permisosGuard],
    data: { modulo: 'PROYECTOS', permiso: 'VIEW', allowedRoles: ROLES_CONFIG.SERVICIOS_PROYECTOS },
  },
  {
    path: 'proyectos/control-fases',
    loadComponent: () =>
      import('./admin/proyecto-control-fases/proyecto-control-fases.component').then(
        (c) => c.ProyectoControlFasesComponent
      ),
    canActivate: [authGuard, permisosGuard],
    data: {
      modulo: 'INVENTARIO',
      permiso: 'VIEW',
      allowedRoles: ROLES_CONFIG.SERVICIOS_ONLY,
    },
  },
  {
    path: 'servicios-pgo',
    loadComponent: () => import('./admin/servicios-pgo/servicios-pgo.component'),
    canActivate: [authGuard, permisosGuard],
    data: { modulo: 'SERVICIOS_PGO', permiso: 'VIEW', allowedRoles: ROLES_CONFIG.LISTADO_SERVICIOS },
  },
  {
    path: 'solicitudes',
    loadComponent: () => import('./admin/solicitudes/solicitudes.component'),
    canActivate: [authGuard, permisosGuard],
    data: { modulo: 'SOLICITUDES', permiso: 'VIEW', allowedRoles: ROLES_CONFIG.SOLICITUDES },
  },
  {
    path: 'catalogos',
    loadComponent: () => import('./admin/catalogos/catalogos.component').then(c => c.CatalogosComponent),
    canActivate: [authGuard, permisosGuard],
    data: { modulo: 'CATALOGOS', permiso: 'VIEW', allowedRoles: ROLES_CONFIG.CATALOGOS },
  },
  {
    path: 'reportesProyectos',
    loadComponent: () => import('./admin/reporte-proyectos/reporte-proyectos.component').then(r => r.ReporteProyectosComponent),
    canActivate: [authGuard, moduleRoleGuard],
    data: { allowedRoles: ROLES_CONFIG.REPORTE_PROYECTOS },
  },
  {
    path: 'asignaciones',
    loadComponent: () => import('./admin/asignaciones/asignaciones.component'),
    canActivate: [authGuard, permisosGuard],
    data: { modulo: 'ASIGNACIONES', permiso: 'VIEW', allowedRoles: ROLES_CONFIG.ASIGNACIONES },
  },
  {
    path: 'asignacion-proyectos',
    loadComponent: () => import('./admin/asignacion-proyectos/asignacion-proyectos.component'),
    canActivate: [authGuard, permisosGuard],
    data: {
      modulo: 'DISPONIBILIDAD',
      permiso: 'VIEW',
      allowedRoles: ROLES_CONFIG.SERVICIOS_ONLY,
    },
  },
  {
    path: 'reportes',
    loadComponent: () => import('./admin/reportes/reportes.component'),
    canActivate: [authGuard, permisosGuard],
    data: { modulo: 'REPORTES', permiso: 'VIEW', allowedRoles: ROLES_CONFIG.REPORTES },
  },
  {
    path: 'reportes-horas',
    loadComponent: () =>
      import('./admin/reportes-horas/reportes-horas.component').then(
        (c) => c.ReportesHorasComponent
      ),
    canActivate: [authGuard, permisosGuard],
    data: { modulo: 'REPORTES_BITACORA', permiso: 'VIEW', allowedRoles: ROLES_CONFIG.REPORTES_BITACORA },
  },
  {
    path: 'admin/cierre-bitacora',
    loadComponent: () =>
      import('./admin/cierre-bitacora/cierre-bitacora.component'),
    canActivate: [authGuard, permisosGuard],
    data: {
      modulo: 'CIERRE_BITACORA',
      permiso: 'VIEW',
      allowedRoles: ROLES_CONFIG.CIERRE_BITACORA,
    },
  },
  {
    path: 'reportesColab',
    loadComponent: () => import('./admin/report-empleado/report-empleado.component').then(r => r.ReportEmpleadoComponent),
    canActivate: [authGuard, permisosGuard],
    data: { modulo: 'REPORTES_COLAB', permiso: 'VIEW', allowedRoles: ROLES_CONFIG.REPORTES_COLAB },
  },
  {
    path: 'ordenventa',
    loadComponent: () => import('./admin/orden-venta/orden-venta.component').then(m => m.OrdenVentaComponent),
    canActivate: [authGuard, permisosGuard],
    data: { modulo: 'ORDEN_VENTA', permiso: 'VIEW', allowedRoles: ROLES_CONFIG.ORDEN_VENTA },
  },
  {
    path: 'ordencompra',
    loadComponent: () => import('./admin/orden-compra/orden-compra.component').then(m => m.OrdenCompraComponent),

    canActivate: [authGuard],
  },
];
